export default "__VITE_ASSET__B4xkJyz5__"